import React from 'react';

export default function Single(props) {
  return (
    <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
        {/* Generator: Sketch 43.2 (39069) - http://www.bohemiancoding.com/sketch */}
        <title>300</title>
      <desc>Created with Sketch.</desc>
      <defs />
      <g id="Page-2-Copy" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id={300} fillRule="nonzero" fill="#95909E">
          <path d="M0,2.00174332 L0,29.9982567 C0,31.103789 0.887646031,32 1.99570348,32 L22.140527,32 C23.2427236,32 24.7664628,31.3707264 25.551197,30.587186 L30.5850335,25.5610074 C31.3664979,24.7807317 32,23.2601074 32,22.1515007 L32,1.99669263 C32,0.893949741 31.1107383,0 29.9982567,0 L2.00174332,0 C0.89621101,0 0,0.889261723 0,2.00174332 L0,2.00174332 Z M29.9982567,2 C30.0038249,2 30,22.1515007 30,22.1515007 C30,22.726605 29.5794322,23.7388023 29.1718968,24.1457177 L24.1380604,29.1718963 C23.7294061,29.5799289 22.7143651,30 22.140527,30 L1.99570348,30 C1.99650806,30 2,2.00174332 2,2.00174332 C2,1.99730764 29.9982567,2 29.9982567,2 L29.9982567,2 Z M24,24.0085302 C24,24.0031869 29.9982925,24 29.9982925,24 L32,22 L30.000385,22 L23.999615,22 C22.8952581,22 22,22.9019504 22,24.0085302 L22,31.9914698 L24,29.9931758 L24,24.0085302 L24,24.0085302 Z" id="Rectangle-1017" transform="translate(16.000000, 16.000000) scale(1, -1) translate(-16.000000, -16.000000) " />
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./app/components/icons/Single.js